import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import ProdOrdIndexActions, { ProdOrdIndexTypes } from '../Stores/ProdOrdIndex/Actions';

const getAppStore = state => state.app;

export function* prodOrdIndexFetchProdOrdIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(ProdOrdIndexActions.prodOrdIndexFetchProdOrdIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `prodOrd/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        ProdOrdIndexActions.prodOrdIndexFetchProdOrdIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ProdOrdIndexActions.prodOrdIndexFetchProdOrdIndexLoading(false));
  }
}

export function* prodOrdIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodOrdDetail/update/${hdrId}`));
}

export function* prodOrdIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/PROD_ORD/${hdrId}/ProdOrdHdr`));
}

export function* prodOrdIndexResetProdOrdFServ02({ hdrIds }) {
  try {
    yield put(ProdOrdIndexActions.prodOrdIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `prodOrd/fServProcess/RESET_PROD_ORD_F_SERV_02/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(ProdOrdIndexActions.prodOrdIndexResetProdOrdFServ02Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ProdOrdIndexActions.prodOrdIndexWorkspaceLoading(false));
  }
}

export const saga = [
  takeLatest(ProdOrdIndexTypes.PROD_ORD_INDEX_FETCH_PROD_ORD_INDEX, prodOrdIndexFetchProdOrdIndex),
  takeLatest(ProdOrdIndexTypes.PROD_ORD_INDEX_GO_TO_DOCUMENT, prodOrdIndexGoToDocument),
  takeLatest(ProdOrdIndexTypes.PROD_ORD_INDEX_GO_TO_AUDIT, prodOrdIndexGoToAudit),
  takeLatest(
    ProdOrdIndexTypes.PROD_ORD_INDEX_RESET_PROD_ORD_F_SERV02,
    prodOrdIndexResetProdOrdFServ02
  )
];
